import React from 'react';
import PropTypes from 'prop-types';

const SrAgentLeaderboardBarChart = ({
  firstPlaceProfilePictureUrl,
  secondPlaceProfilePictureUrl,
  thirdPlaceProfilePictureUrl,
}) => (
  <div className='SrLeaderboardBarChart'>
    <div className='vertical'>
      <img
        alt='First Place'
        className='profileImage'
        src={secondPlaceProfilePictureUrl}
      />
      <div className='spacing' />
      <div className='bar second'>
        <span className='rank second'>2</span>
      </div>
    </div>
    <div className='vertical'>
      <img
        alt='Second Place'
        className='profileImage'
        src={firstPlaceProfilePictureUrl}
      />
      <div className='spacing' />
      <div className='bar first'>
        <span className='rank first'>1</span>
      </div>
    </div>
    <div className='vertical'>
      <img
        alt='Third Place'
        className='profileImage'
        src={thirdPlaceProfilePictureUrl}
      />
      <div className='spacing' />
      <div className='bar third'>
        <span className='rank third'>3</span>
      </div>
    </div>
  </div>
);

SrAgentLeaderboardBarChart.propTypes = {
  firstPlaceProfilePictureUrl: PropTypes.string.isRequired,
  secondPlaceProfilePictureUrl: PropTypes.string.isRequired,
  thirdPlaceProfilePictureUrl: PropTypes.string.isRequired,
};

SrAgentLeaderboardBarChart.displayName = 'SrAgentLeaderboardBarChart';

export default SrAgentLeaderboardBarChart;
